import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSubdir } from 'app/actions/SubdirectionsActions';
import { getSubirs } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function SubdirectionsContainer(props){
	let dispatch = useDispatch();
    let subdirs = useSelector(getSubirs);

     useEffect(() => {
        if (isEmpty(subdirs)) fetchSubdirAction();
    }, []);
    const fetchSubdirAction = () => dispatch(fetchSubdir());

	return (props.children({subdirs}));
}